/* Base theme script. Progressive enhancement only: every feature below has a working no-script
   fallback (forms post to Shopify, the cart icon links to /cart, details/summary open natively).
   Modules: cart (drawer + section rendering), header (sticky show-on-scroll-up, menu drawer),
   product (variants, image swatches, gallery, zoom, sticky buy, recently viewed),
   collection (filters auto-submit, load more). No dependencies. Motion is feedback only and
   every transition respects prefers-reduced-motion through the stylesheet. */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- money -------------------------------------------------------------------------- */
  function money(cents) {
    var format = T.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';
    if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(decimal));
  }

  /* ---- cart --------------------------------------------------------------------------- */
  var Cart = {
    drawer: $('[data-drawer]'),
    lastFocus: null,
    sectionIds: function () {
      var ids = ['cart-icon-bubble'];
      if (this.drawer) ids.push('cart-drawer');
      var page = $('[data-cart-section]');
      if (page) ids.push(page.getAttribute('data-cart-section'));
      return ids;
    },
    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      var first = $('[data-cart-close]', this.drawer);
      if (first) first.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    bump: function () {
      var count = $('#cart-icon-bubble .cart-count');
      if (!count) return;
      count.classList.remove('is-bumped');
      void count.offsetWidth;
      count.classList.add('is-bumped');
    },
    render: function (sections) {
      if (!sections) return;
      var parser = new DOMParser();
      Object.keys(sections).forEach(function (id) {
        var doc = parser.parseFromString(sections[id], 'text/html');
        if (id === 'cart-icon-bubble') {
          var bubble = $('#cart-icon-bubble');
          var fresh = $('#cart-icon-bubble', doc);
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
        } else if (id === 'cart-drawer') {
          var target = $('#CartDrawer');
          var next = $('#CartDrawer', doc);
          if (target && next) target.innerHTML = next.innerHTML;
        } else {
          var page = $('[data-cart-section="' + id + '"]');
          var nextPage = $('[data-cart-section]', doc);
          if (page && nextPage) page.innerHTML = nextPage.innerHTML;
        }
      });
      this.bump();
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    change: function (line, quantity) {
      var self = this;
      var key = line.getAttribute('data-key');
      var error = $('[data-line-error]', line);
      line.classList.add('is-loading');
      var body = { id: key, quantity: quantity, sections: this.sectionIds().join(','), sections_url: window.location.pathname };
      return this.request(T.routes.cart_change, body).then(function (json) {
        if (json.errors || json.status) {
          if (error) error.textContent = json.errors || json.message || json.description || 'Could not update the cart.';
          line.classList.remove('is-loading');
          return;
        }
        self.render(json.sections);
      }).catch(function () {
        if (error) error.textContent = 'Could not update the cart. Please try again.';
        line.classList.remove('is-loading');
      });
    },
    add: function (form) {
      var self = this;
      var button = $('[data-add-button]', form) || $('button[type="submit"]', form);
      var error = $('[data-product-error]');
      var fd = new FormData(form);
      fd.append('sections', this.sectionIds().join(','));
      fd.append('sections_url', window.location.pathname);
      if (error) error.textContent = '';
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      return fetch(T.routes.cart_add, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) {
            if (error) error.textContent = json.description || json.message || 'This item could not be added.';
            return;
          }
          if (button) {
            button.classList.add('is-done');
            setTimeout(function () { button.classList.remove('is-done'); }, 1600);
          }
          if (self.drawer) { self.render(json.sections); self.open(); }
          else { window.location.href = T.routes.cart_url; }
        })
        .catch(function () { if (error) error.textContent = 'Something went wrong. Please try again.'; })
        .then(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); } });
    }
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && Cart.drawer) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]') || (Cart.drawer && e.target === $('[data-drawer-backdrop]', Cart.drawer))) { e.preventDefault(); Cart.close(); return; }
    var qty = e.target.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      var line = qty.closest('[data-line]');
      var input = $('[data-qty-input]', line);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qty.getAttribute('data-qty-change'), 10));
      input.value = next;
      Cart.change(line, next);
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); Cart.change(remove.closest('[data-line]'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) Cart.change(input.closest('[data-line]'), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Cart.drawer && Cart.drawer.classList.contains('is-open')) Cart.close();
      $$('details[open].menu, details[open].search, details[open].facets').forEach(function (d) { d.removeAttribute('open'); });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form);
  });

  /* ---- header: sticky show-on-scroll-up, menu drawer, search --------------------------- */
  var header = $('[data-header]');
  var menu = $('[data-menu]');
  if (header && document.body.classList.contains('has-sticky-header')) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var menuOpen = menu && menu.open;
        header.classList.toggle('is-stuck', y > 8);
        if (!menuOpen && !document.body.classList.contains('drawer-open')) {
          if (y > lastY + 6 && y > 120) header.classList.add('is-hidden');
          else if (y < lastY - 6 || y <= 120) header.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }
  if (menu) {
    menu.addEventListener('toggle', function () {
      document.body.classList.toggle('menu-open', menu.open);
      if (menu.open && header) header.classList.remove('is-hidden');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-close]') && menu) { menu.removeAttribute('open'); return; }
    $$('details[open].menu, details[open].search, details[open].facets').forEach(function (d) {
      if (e.target === d || !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('details.search').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = $('input', d); if (i) i.focus(); } });
  });

  /* ---- product: variants, gallery, zoom, sticky buy, recently viewed ----------------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var button = form ? $('[data-add-button]', form) : null;
    var buttonLabel = button ? $('.btn__label', button) : null;
    var priceEl = $('[data-price]', root);
    var shipBadge = $('[data-ship-badge]', root);
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var gallery = $('[data-gallery]', root);
    var track = gallery ? $('[data-gallery-track]', gallery) : null;
    var slides = track ? $$('[data-media-id]', track) : [];
    var thumbs = gallery ? $$('[data-thumb-for]', gallery) : [];
    var counter = gallery ? $('[data-counter]', gallery) : null;
    var lightbox = $('[data-lightbox]', root);
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    var sticky = $('[data-sticky-buy]', root);
    var strings = { add: root.getAttribute('data-text-add') || 'Add to cart', soldOut: root.getAttribute('data-text-sold-out') || 'Sold out', unavailable: root.getAttribute('data-text-unavailable') || 'Unavailable' };

    function setButtonText(text) { if (buttonLabel) buttonLabel.textContent = text; else if (button) button.textContent = text; }
    function selectedOptions() {
      var out = [];
      $$('[data-option-index]:checked', root).forEach(function (input) { out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value; });
      return out;
    }
    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < options.length; j++) { if (variants[i].o[j] !== options[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
    function currentSlide() {
      var list = visibleSlides();
      var index = 0;
      var best = Infinity;
      list.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < best) { best = d; index = i; } });
      return { list: list, index: index, slide: list[index] };
    }
    function updateCounter() {
      if (!track) return;
      var c = currentSlide();
      if (counter) counter.textContent = (c.index + 1) + ' / ' + c.list.length;
      thumbs.forEach(function (t) {
        var active = c.slide && t.getAttribute('data-thumb-for') === c.slide.getAttribute('data-media-id');
        t.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && t.scrollIntoView && !t.hidden) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
    function scrollToMedia(id, instant) {
      var slide = slides.filter(function (s) { return s.getAttribute('data-media-id') === String(id); })[0];
      if (!slide || !track || slide.hidden) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function filterGallery(color) {
      if (isNaN(colorIndex) || !gallery) return;
      var probe = '|' + color + '|';
      slides.forEach(function (s) { var colors = s.getAttribute('data-colors') || ''; s.hidden = colors !== '' && colors.indexOf(probe) === -1; });
      thumbs.forEach(function (t) { var colors = t.getAttribute('data-colors') || ''; t.hidden = colors !== '' && colors.indexOf(probe) === -1; });
    }
    function markAvailability(options) {
      /* Only the visible buttons: the colour select and the hidden mirror radios that back it also
         carry data-option-index, and for those nextElementSibling is not a label. */
      $$('.option__values [data-option-index]', root).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var test = options.slice();
        test[idx] = input.value;
        var available = variants.some(function (v) {
          if (!v.a) return false;
          for (var j = 0; j < test.length; j++) { if (test[j] !== undefined && v.o[j] !== test[j]) return false; }
          return true;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
      options.forEach(function (value, i) { var label = $('[data-selected-label="' + i + '"]', root); if (label) label.textContent = value; });
    }
    function thumbSrcFor(mediaId) {
      var thumb = thumbs.filter(function (t) { return t.getAttribute('data-thumb-for') === String(mediaId); })[0];
      var img = thumb && $('img', thumb);
      return img ? img.currentSrc || img.src : null;
    }
    function apply(initial) {
      var options = selectedOptions();
      var variant = findVariant(options);
      markAvailability(options);
      if (!isNaN(colorIndex)) filterGallery(options[colorIndex]);
      if (variant) {
        if (idInput) { idInput.value = variant.id; idInput.disabled = false; }
        if (priceEl) priceEl.innerHTML = variant.c > variant.p ? '<s>' + money(variant.c) + '</s> ' + money(variant.p) : money(variant.p);
        if (shipBadge) shipBadge.hidden = !(threshold > 0 && variant.p >= threshold);
        if (button) { button.disabled = !variant.a; setButtonText(variant.a ? strings.add : strings.soldOut); }
        if (sticky) {
          var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(variant.p);
          var sv = $('[data-sticky-variant]', sticky); if (sv && variant.t) sv.textContent = variant.t;
          var st = $('[data-sticky-thumb]', sticky); var src = variant.m ? thumbSrcFor(variant.m) : null; if (st && src) st.src = src;
          var sb = $('button', sticky); if (sb) sb.disabled = !variant.a;
        }
        if (variant.m) scrollToMedia(variant.m, initial);
        if (!initial && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        if (idInput) idInput.disabled = true;
        if (button) { button.disabled = true; setButtonText(strings.unavailable); }
      }
      updateCounter();
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) apply(false); });
    if (variants.length) apply(true);

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { updateCounter(); ticking = false; });
      }, { passive: true });
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-for]');
        if (thumb) { scrollToMedia(thumb.getAttribute('data-thumb-for')); return; }
        var nav = e.target.closest('[data-gallery-nav]');
        if (nav) {
          var c = currentSlide();
          var next = c.list[Math.min(c.list.length - 1, Math.max(0, c.index + parseInt(nav.getAttribute('data-gallery-nav'), 10)))];
          if (next) track.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
          return;
        }
        if (lightbox && (e.target.closest('[data-zoom-open]') || e.target.closest('.gallery__slide'))) {
          var slide = e.target.closest('.gallery__slide') || currentSlide().slide;
          var src = slide && slide.getAttribute('data-zoom');
          if (!src || !lightbox.showModal) return;
          var img = $('[data-lightbox-img]', lightbox);
          img.src = src;
          lightbox.showModal();
        }
      });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) lightbox.close(); });
      }
      updateCounter();
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-accordion]');
      if (!opener) return;
      var target = document.getElementById(opener.getAttribute('data-open-accordion'));
      if (target) target.open = true;
    });

    if (sticky && button && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var io = new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        var show = out && mq.matches;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      }, { threshold: 0 });
      io.observe(button);
      $('button', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else button.click();
      });
    }

    /* recently viewed: last 8 products in this browser only */
    var recentEl = $('script[data-recent-item]', root);
    var recentGrid = $('[data-recent-grid]');
    try {
      var item = recentEl ? JSON.parse(recentEl.textContent) : null;
      var stored = JSON.parse(window.localStorage.getItem('theme:recent') || '[]');
      var others = stored.filter(function (r) { return item && r.h !== item.h; });
      if (recentGrid && others.length) {
        recentGrid.innerHTML = others.slice(0, 6).map(function (r) {
          return '<article class="product-card"><a href="' + r.u + '"><div class="product-card__media">' + (r.i ? '<img src="' + r.i + '" width="480" height="600" loading="lazy" alt="">' : '') + '</div><h3>' + r.t.replace(/</g, '&lt;') + '</h3><p class="product-card__meta">' + r.p + '</p></a></article>';
        }).join('');
        var section = recentGrid.closest('[data-recent]');
        if (section) section.hidden = false;
      }
      if (item) window.localStorage.setItem('theme:recent', JSON.stringify([item].concat(others).slice(0, 8)));
    } catch (err) { /* storage unavailable: nothing to show */ }
  });

  /* ---- collection: filters and load more --------------------------------------------- */
  $$('form[data-facets]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 600); return; }
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    var grid = $('[data-product-grid]');
    if (!grid) return;
    more.classList.add('is-loading');
    fetch(more.getAttribute('href'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = $('[data-product-grid]', doc);
        var nextMore = $('[data-load-more]', doc);
        if (nextGrid) Array.prototype.slice.call(nextGrid.children).forEach(function (child) { grid.appendChild(child); });
        if (nextMore) { more.setAttribute('href', nextMore.getAttribute('href')); more.classList.remove('is-loading'); }
        else { more.closest('[data-load-more-wrap]').hidden = true; var pag = $('[data-pagination]'); if (pag) pag.hidden = true; }
        window.history.replaceState({}, '', more.getAttribute('href'));
      })
      .catch(function () { window.location.href = more.getAttribute('href'); });
  });
})();
